// 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  .group-div {
    padding-top: 20px;
    padding-left: 20px;
  }
  .message {
    padding-top: 25px;
    padding-left: 20px;
  }
  .group-span {
    font-weight: bolder;
  }
  .button-back {
    box-sizing: border-box;
    height: 40px;
    width: 160px;
    border: 1px solid var(--border-color-base);
    border-radius: 4px;
    background-color: var(--white);
    color: var(--border-color-base);
    font-weight: bold;
  }
  .button-ok {
    box-sizing: border-box;
    height: 40px;
    width: 160px;
    border: 1px solid var(--border-color-base);
    border-radius: 4px;
    background-color: var(--border-color-base);
    color: var(--white);
    font-weight: bold;
  }
`;
// 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
